import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'df-repeat',
  templateUrl: './repeat.component.html',
  styleUrls: ['./repeat.component.scss']
})
export class RepeatComponent implements OnInit {

  @Input() states: string[] = [];
  @Input() className: string = '';
  @Input() state: number = 0;

  isExpanded: boolean = false;
  showRepeatPopup: boolean = false;

  @Output() select = new EventEmitter<number>();

  @HostListener('document:click', ['$event'])
  clickout(event: any) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.isExpanded = false;
    }
  }

  constructor(private eRef: ElementRef) { }

  ngOnInit(): void {
  }

  expand() {
    this.isExpanded = !this.isExpanded;
  }

  selectState(i: number) {
    this.state = i;
    this.isExpanded = false;
    this.showRepeatPopup = true;

    this.select.emit(i);
  }
}
